export default {
    legend: {
        OSM: 'OpenStreetMap',
        SCAN25: 'Plan IGN',
        ORTHO: 'Photo aérienne',
    },
    declarations: {
        mayor_decision: {
            index: 'Décision du maire <i><small>(Des préconisations spécifiques peuvent avoir été émises pour ce chantier, merci d\'en prendre connaissance en ouvrant les onglets Documents & commentaires, ONF, CLE et CDBD)</small></i>',
        },
        cdbd_decision: {
            index: 'Avis CDBD',
            null: 'Pas d\'avis',
            true: 'Favorable',
            false: 'Défavorable',
        },
        cle_decision: {
            index: 'Avis CLE',
            null: 'Pas d\'avis',
            true: 'Favorable',
            false: 'Défavorable',
        },
        ddt_decision: {
            index: 'Avis DDT',
            null: 'Pas d\'avis',
            true: 'Favorable',
            false: 'Défavorable',
        },
        declarant_type: {
            index: 'Qualité du déclarant',
            farmer_have_right: 'Agriculteur Ayant droit',
        },
    },
}
